import type { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LogService } from '../../services/log.service';

@Component({
  selector: 'app-bug-report-dialog',
  templateUrl: './bug-report-dialog.component.html',
  styleUrls: ['./bug-report-dialog.component.scss']
})
export class BugReportDialogComponent implements OnInit {

  userAgent = '';
  appAppUrl = '';
  appApiUrl = '';
  appVersion = '';
  appEnv = '';
  logs = '';

  constructor(
    private readonly log: LogService
  ) { }

  ngOnInit(): void {
    this.setEnvValues();
    this.setLogs();
  }

  openGithub(): void {
    window.open('https://github.com/cyrilvincent/mypacs-cloud/issues/new', undefined, 'noopener');
  }

  private setEnvValues(): void {
    this.userAgent = window.navigator.userAgent;
    this.appAppUrl = window.location.href;
    this.appApiUrl = environment.apiUrl;
    this.appVersion = '1.0.0';
    this.appEnv = environment.name;
  }

  private setLogs(): void {
    this.logs = this.log.allLogs;
  }
}
